export { default } from './ParentModelSection';
